<template>
      <form class="app-pay-form" @submit.prevent="onSubmit">
          <slot name="content"></slot>
          <div class="col">
            <button type="submit" class="button primary block">Para Yatır</button>
          </div>
      </form>
</template>

<script>
  export default{
    props: ['onSubmit']
  }
</script>